import request from '@/utils/request'

// 查询列表
export function listRoutingHeader (query) {
  return request({
    url: '/bom/bomRoutingHeader/list',
    method: 'get',
    params: query
  })
}

// 详情
export function listRoutingHeaderDetail (query) {
  return request({
    url: `/bom/bomRoutingHeader/queryInfo`,
    method: 'get',
    params: query
  })
}

// 详情-标准工艺路线
export function listRoutingHeaderDetailId (id) {
  return request({
    url: `/bom/bomRoutingHeader/${id}`,
    method: 'get'
  })
}

// 加工组织编码
export function listinventOrg (query) {
  return request({
    url: `/system/user/inventOrg`,
    method: 'get',
    params: query
  })
}

// 工艺路线
export function bomRoutingHeaderFindList (query) {
  return request({
    url: `/bom/bomRoutingHeader/findList`,
    method: 'get',
    params: query
  })
}

// 工序编码
export function bomOperationFindList (query) {
  return request({
    url: '/bom/bomOperation/findList',
    method: 'get',
    params: query
  })
}

// 修改
export function updateRoutingHeader (data) {
  return request({
    url: '/bom/bomRoutingHeader',
    method: 'put',
    data: data
  })
}

// 新增
export function addRoutingHeader (data) {
  return request({
    url: '/bom/bomRoutingHeader',
    method: 'post',
    data: data
  })
}

// 物料编码-SKU
export function pullDownListAttribute (query) {
  return request({
    url: '/mdm/mdmItemOrganizationItem/findList',
    method: 'get',
    params: query
  })
}

// 物料编码-SPU
export function findSpuCodeList (query) {
  return request({
    url: '/mdm/mdmItemOrganizationItem/findSpuCodeList',
    method: 'get',
    params: query
  })
}

// 替代项
export function bomAlternateDesignators (query) {
  return request({
    url: '/bom/bomAlternateDesignators/findList',
    method: 'get',
    params: query
  })
}
